var _Path, _Path2, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgFitnessOutline(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 50,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#fitness-outline_svg__clip0_469_2)",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1.484 30.691H13.75l3.067-4.345 4.096 6.523 5.105-10.879 4.096 15.224 3.067-6.523h15.334"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M43.916 26.346a26.639 26.639 0 002.552-10.71c0-16.73-19.054-18.024-21.468-1.295C22.576-2.388 3.522-1.094 3.522 16.919a26.174 26.174 0 001.87 9.469M10.13 35.037c4.203 5.769 9.207 10.824 14.84 14.992a88.131 88.131 0 0013.85-14.992"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "fitness-outline_svg__clip0_469_2"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(0 .843)",
    d: "M0 0h50v50.764H0z"
  })))));
}

export default SvgFitnessOutline;